'use client';

import { FC } from 'react';
import { Expandable } from '@provider-directory/components/expandable/expandable';
import { cn } from '@provider-directory/functions/cn';
import { InsuranceCarrier } from '@provider-directory/types';

interface CarrierItemProps {
  carrier: InsuranceCarrier;
}

export const InsuranceCarrierItem: FC<CarrierItemProps> = ({ carrier }) =>
  carrier.plans && carrier.plans.length > 0 ? (
    <Expandable
      title={carrier.name}
      testIdPrefix={`insurance-carrier-${carrier.name}`}
      triggerClassName={cn('border-t border-gray-200 px-2 font-semibold')}
      contentClassName={'px-2 !pb-0'}
    >
      <ul className={'flex flex-col gap-4'}>
        {carrier.plans.map((plan) => (
          <li key={plan} className={'px-2 text-body-medium last:pb-4'}>
            {plan}
          </li>
        ))}
      </ul>
    </Expandable>
  ) : (
    <div className={cn('border-t border-gray-200 px-2 py-4 font-semibold')}>
      {carrier.name}
    </div>
  );
